import { GET_SCHOOLS_CATEGORIES } from "../../../../constants/SchoolConstants";
import getSchoolCategoriesSaga from "../actions/getSchoolCategoriesSaga";
import { takeLatest } from "redux-saga/effects";

export default function* getSchoolCategoriesWatcher() {
    yield takeLatest(GET_SCHOOLS_CATEGORIES, getSchoolCategoriesSaga);
}
